<template>
  <div>
    <div v-if="newsList.length">
      <div
        v-for="(item, index) in newsList"
        :key="index"
        class="list"
        @click="newDetail(item)"
      >
        <div class="details-con">
          <div class="title">{{ item.title }}</div>
          <div class="newsText" >{{item.summary}}</div>
          <div class="article-info">
            <div class="avatar">
              <img src="../../../assets/image/header-img.png" alt="" />
            </div>
            <div class="infos">
              <div class="author">{{ item.publishUserName }}</div>
              <div class="date-num">
                <span class="date">{{ item.publishTime | activityTime }}</span>
                <span class="el-icon-view"></span>
                <span class="skim-num">{{ item.pv }}浏览量</span>
              </div>
            </div>
          </div>
        </div>
        <div class="details-img" v-if="item.images">
          <img :src="item.images" alt="" width="100%;" />
        </div>
      </div>
      <div class="pagination" v-show="total">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-size="pageSize"
          :current-page.sync="currentPage"
          :total="total"
          background
          layout="prev, pager, next"
        >
        </el-pagination>
      </div>
    </div>
    <div class="no-msg" v-else>
      <img src="../../../assets/news-no-msg.png" alt="">
      <span>暂无数据</span>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      total: 0,
      currentPage: 1,
      pageSize: 10,
      newsList: [],

    };
  },
  props:{
     type:{
        type:String,
        default:''
     }
  },
  methods: {
    newDetail(item) {
      let params={
        id:item.id,
        pv:Number(item.pv)+1
      }
      this.changePv(params).then(()=>{
           this.$router.push({
        path: "/newsDetail",
        query: {id: item.id,  channelId:this.type},
      });
      })

    },
   async changePv(params){
        const res= await this.API.operateManage.portalNewsUpdateFn(params)
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      // this.userQuery.size = val
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getdetail();
    },
    async getdetail() {
      let params = {
        size: this.pageSize,
        current: this.currentPage,
        channelId: this.type,
      };

      const res = await this.API.operateManage.getPortalNewsPageFn(params);
      if (res.code ==200) {
        this.total = res.data.total;
        this.newsList = res.data.records;
      }
    },
  },
  filters: {
    activityTime: function (value) {
      if (value == null || value == "" || value == undefined) {
        return "";
      } else {
        let date = new Date(value);
        let Y = date.getFullYear() + "-";
        let M =
          (date.getMonth() + 1 < 10
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1) + "-";
        let D =
          (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
        let h =
          (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) +
          ":";
        let m =
          (date.getMinutes() < 10
            ? "0" + date.getMinutes()
            : date.getMinutes()) + ":";
        let s =
          date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
        // return Y + M + D + h + m + s;
        return Y + M + D
      }
    }, //时间戳转换
  },
  mounted() {
    if (this.type) {
      //  this.getdetail();
    }

  },

};
</script>
<style lang="scss" scoped>
  .no-msg{
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    margin-top:100px;
    img{
      width: 280px;
      height: 134px;
    }
    span{
      font-family: "Microsoft YaHei";
      font-weight: 400;
      font-size: 15px;
      color: #16181a;
    }
  }
.list {
  //   height: 194px;
  background: #ffffff;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.08);
  border-radius: 6px;
  display: flex;
  margin-bottom: 15px;
  cursor: pointer;
  transition: all 0.3s;
  &:hover {
    cursor: pointer;
    transform: scale(1.05) translateZ(0); // scale 控制缩放大小
  }
}

.details-con {
  background: #fff;
  width: 75%;
  padding: 12px 24px;
  border-radius: 6px;

  .title {
    color: #16181a;
    font-size: 18px;
    height: 40px;
    width: 100%;
    margin-top: 7px;
    font-weight: bold;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .newsText {
    width: 100%;
    height: 47px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    overflow: hidden;
    color: #999999;
    line-height: 20px;
    padding: 5px 5px;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .article-info {
    display: flex;
    align-items: center;
    margin-top: 30px;
    .avatar {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      overflow: hidden;
      margin-right: 10px;
      img {
        width: 100%;
        height: auto;
      }
    }
    .infos {
      font-size: 12px;
      line-height: 20px;
      .author {
        font-size: 12px;
        font-family: Microsoft YaHei;

        color: #495770;
      }
      .date-num {
        span {
          color: #999999;
          font-size: 12px;
        }
        .date {
          margin-right: 20px;
        }
        .skim-num {
          margin-left: 10px;
        }
      }
    }
  }
  .content {
    padding: 20px 0px;
    display: flex;
    .sub-title {
      margin-left: 10px;
      div {
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #495770;
        line-height: 18px;
      }
      // margin-top: 10px;
    }
    .title-flex {
      display: flex;
    }
  }
}
.details-img {
  width: 20%;
  margin: auto;
  padding: 12px;
}
.pagination {
  .el-pagination {
    float: right;
  }
}
</style>
<style lang="scss">
.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
  background: white;
  color: rgba(0, 0, 0, 0.65);

  border-radius: 6px;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background: rgba(0, 82, 217, 1);
}
</style>
